import { render, staticRenderFns } from "./HeadingBlock.vue?vue&type=template&id=42beb43a&scoped=true&lang=pug&"
import script from "./HeadingBlock.vue?vue&type=script&lang=js&"
export * from "./HeadingBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeadingBlock.vue?vue&type=style&index=0&id=42beb43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42beb43a",
  null
  
)

/* custom blocks */
import block0 from "./HeadingBlock.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports